import { defineRule, configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import id from '@vee-validate/i18n/dist/locale/id.json'
import AllRules from '@vee-validate/rules'

defineRule('_validate_datetime', value => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true
  }

  try {
    const a = (new Date(value)).toString().toLowerCase()
    
    if (a.indexOf('invalid date') > -1) {
      return 'This field is invalid date/time'
    }

    return true
  } catch {
    return 'This field is invalid date/time'
  }
})

defineRule('alphanumeric', value => {
  if (!value) return 'Password wajib diisi.'
  const regex = /^(?=.*[a-zA-Z])(?=.*\d).+$/
  return regex.test(value)
    ? true
    : 'Username hanya boleh huruf, angka, underscore'
})

defineRule('min_time', (value, [minTime]) => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true
  }

  const vTime = value.toString().split(':')
  const mTime = minTime.toString().split(':')

  if (vTime[0] < mTime[0]) {
    return 'This field minimum time is ' + minTime
  } else if (vTime[0] === mTime[0] && vTime[1] < mTime[1]) {
    return 'This field minimum time is ' + minTime
  }

  return true
})

defineRule('max_time', (value, [maxTime]) => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true
  }

  const vTime = value.toString().split(':')
  const mTime = maxTime.toString().split(':')

  if (vTime[0] > mTime[0]) {
    return 'This field maximum time is ' + maxTime
  } else if (vTime[0] === mTime[0] && vTime[1] > mTime[1]) {
    return 'This field maximum time is ' + maxTime
  }

  return true
})

defineRule('has_space', value => {
  if (!value || !value.length) {
    return true
  }

  if (value.toString().indexOf(' ') > -1) {
    return 'This field should be seperated with underscore, not space.'
  }

  return true
})

defineRule('is_duplicate_value', value => {
  if (value === 'Y') {
    return 'This field is duplicate'
  }

  return true
})

defineRule('is_invalid', (value, [cause]) => {
  if (value === 'Y') {
    return 'This field is invalid causes: ' + cause
  }

  return true
})

defineRule('minAge17', (value) => {
  if (!value) return 'Tanggal lahir wajib diisi'

  const [year, month, day] = value.split('-').map(Number)
  const today = new Date()
  const birthday = new Date(year, month - 1, day)

  let age = today.getFullYear() - birthday.getFullYear()
  const m = today.getMonth() - birthday.getMonth()

  if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
    age--
  }

  console.log('✅ DOB:', value, '| Age:', age, '| Today:', today.toISOString().split('T')[0])

  return age >= 17 || 'Usia minimal harus 17 tahun'
})

Object.keys(AllRules).forEach(rule => { 
  defineRule(rule, AllRules[rule]) 
})

configure({ 
  validateOnInput: true, 
  generateMessage: localize('id', id) 
})
